import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ContingentBundle } from './model/contingent-bundle.model';
import { ErrorCode } from '@angular/compiler-cli/src/ngtsc/diagnostics';

export const ContingentBundleApiActions = createActionGroup({
    source: 'API/ContingentBundle',
    events: {
        'load contingent bundles': emptyProps()
    }
});

export const ContingentBundleActions = createActionGroup({
    source: 'ContingentBundle',
    events: {
        'load contingent bundles success': props<{ contingentBundles: ContingentBundle[] }>(),
        'load contingent bundles failure': props<{ error: ErrorCode }>()
    }
});
